import gql from "graphql-tag"

const RESTART_SHIPPING_FEE_MODIFICATION = gql`
  mutation restartOrderModificationShippingFees($modificationId: ID!, $input: InputOrderModificationShippingFeesStart!) {
    Order {
      restartOrderModificationShippingFees(modificationId: $modificationId, input: $input) {
        status
      }
    }
  }
`

export default RESTART_SHIPPING_FEE_MODIFICATION
